class AccordianItems extends HTMLElement{
  constructor(){
    super();
    this.accordian();
  }
  accordian(){
    const target = this.querySelectorAll('accordian-target')
    for(let i=0; i<=target.length; i++){
      if(target[i]){target[i].addEventListener('click',this.toggler.bind(target[i]))}
    }
  }
  toggler(target){
    this.parentNode.classList.toggle('targetHitted'); var node = this.parentNode.parentNode.firstChild;
    while(node){ if(node !== this.parentNode && node.nodeType === Node.ELEMENT_NODE ) node.classList.remove('targetHitted'); node = node.nextElementSibling || node.nextSibling; }
  }
}
customElements.define('accordian-items', AccordianItems)